module.exports = __webpack_public_path__ + "static/media/partitions_gwp_10y_y.787cda23.csv";